import { render } from "./VehicleInfoWrapperComponent.vue?vue&type=template&id=5152f11b&ts=true"
import script from "./VehicleInfoWrapperComponent.vue?vue&type=script&lang=ts"
export * from "./VehicleInfoWrapperComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/home/atnbusrent/public_html/fleet-manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__